import React, { useEffect } from 'react';
import { useRouter } from 'next/router';

const WholesalePartsCenter: React.FC = () => {
  const router = useRouter();

  useEffect(() => {
    router.push('/wholesale-parts-hub/parts-overview', undefined, {
      shallow: true,
    });
  });

  return null;
};

export default WholesalePartsCenter;
